import {determineLanguage, getCookie, setCookie} from './common/util';
import * as focusTrap from "focus-trap";

const cookieDurationInDays = 30;
const cookieName = "cookie-consent";

$(function () {
    init();

    $('.cookie-consent-container button').on('click', function () {
        accept();
        location.reload();
    });
    $('#onetrust-reject-all-handler').on('click', function () {
        location.reload();
    });
});

function init() {
    let lang = determineLanguage();

    if (!getCookie(cookieName)) {
        let $cookieConsent = $('<div/>', {'class': 'cookie-consent'});
        let $cookieConsentContainer = $('<div/>', {'class': 'cookie-consent-container'});
        let $itemText = $('<div/>', {'class': 'item-text'});
        let $itemLink = $('<div/>', {'class': 'item-link'});
        let $itemButton = $('<div/>', {'class': 'item-button'});

        if (typeof lang !== 'undefined' && lang === 'en') {
            $itemText.append('<div>This website uses cookies to provide you with an optimal navigation experience. <a href="/en/cookies" aria-label="learn more about cookies" tabindex="0" rel="noopener noreferrer nofollow" target="_blank" onclick="pushDataLayerCookieConsentConditions();">Cookies</a></div>');
            $itemButton.append('<button class="btn btn-primary"><span>i understand</span></button>');
        } else {
            $itemText.append('<div>Ce site utilise des témoins (appelés « Cookies »), afin de vous fournir une expérience de navigation optimale. <a href="/temoins" aria-label="en apprendre sur les cookies" tabindex="0" rel="noopener noreferrer nofollow" target="_blank" onclick="pushDataLayerCookieConsentConditions();">Témoins </a></div>');
            $itemButton.append('<button class="btn btn-primary"><span>j\'ai compris</span></button>');
        }

        $cookieConsentContainer.append($itemText, $itemLink, $itemButton);
        $cookieConsent.append($cookieConsentContainer);
        $('body').append($cookieConsent);
    }
}

function accept() {
    setCookie(cookieName, cookieDurationInDays);
    $('.cookie-consent').fadeOut();
};